module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Bold-Hestia.bcacd00.woff";